import type { AsyncThunkApiConfig } from '@/store'

import { createAsyncThunk } from '@reduxjs/toolkit'
import { RejectError } from '../../typings'

/**
 * GetOrder
 *
 * @private
 */
export const getOrder = createAsyncThunk<
  // Return type of the payload creator
  uui.domain.actions.rpc.order.GetOrderResult['result'],
  // First argument to the payload creator
  uui.domain.actions.rpc.order.GetOrderAction['payload'],
  // thunk API
  AsyncThunkApiConfig<RejectError>
>('rpc/order/getOrder', async (payload, thunkApi) => {
  try {
    const rpc = thunkApi.extra.domainProxy.getRpc()

    const response = await rpc('rpc/order/getOrder', {
      category: 'rpc',
      type: 'rpc/order/getOrder',
      payload,
    })

    if (response.type === 'rpc-failure') {
      return thunkApi.rejectWithValue({
        type: 'rpcFailure',
        message: response.errorMessage,
        error: response,
      })
    }

    return response.result
  } catch (error) {
    thunkApi.extra.journal.main(
      `Unknown error on getOrder`,
      { tags: ['rpc', 'order'], info: payload },
      'error',
    )

    return thunkApi.rejectWithValue({
      type: 'unknown',
      message: `getOrder call failed`,
      error,
    })
  }
})
